module.exports = __webpack_public_path__ + "static/media/prewax.cd5ee5d0.jpg";